{
    "ChangeMenuTitle": "Rapporto di modifica",
    "UnknownReport": "[Rapporto sconosciuto]",
    "NoSuitableReportsAvailable": "Non sono disponibili rapporti adeguati.",
    "DashboardChangeFolderEmpty": "Tutti i report presenti in questa cartella sono già stati utilizzati in questo dashboard...",
    "DashboardList_SectionHeader": "Elenco",
    "DashboardList_Add": "Aggiungi",
    "DashboardList_AddMenuTitle": "Aggiungi e rimuovi",
    "DashboardList_MoveUp": "Salire",
    "DashboardList_MoveDown": "Scendere",
    "DashboardList_Remove": "Rimuovere",
    "DashboardList_RemoveAll": "Rimuovere tutti",
    "DashboardList_RemoveAllConfirmMessage": "È sicuro di voler rimuovere tutte le segnalazioni?",
    "NAME": "DashboardList"
}